export function formatNotificationDate(dateString: string): string {
  const date = new Date(dateString);

  const now = new Date();

  const diff = (now.getTime() - date.getTime()) / 1000; // seconds

  let timeAgoNumber;

  if (diff < 60) return "Just now";

  if (diff < 3600) {
    timeAgoNumber = Math.floor(diff / 60);

    return `${timeAgoNumber} minute${timeAgoNumber > 1 ? "s" : ""} ago`;
  }

  if (diff < 86400) {
    timeAgoNumber = Math.floor(diff / 3600);

    return `${timeAgoNumber} hour${timeAgoNumber > 1 ? "s" : ""} ago`;
  }

  if (diff < 604800) {
    timeAgoNumber = Math.floor(diff / 86400);

    return `${timeAgoNumber} day${timeAgoNumber > 1 ? "s" : ""} ago`;
  }

  return date.toLocaleDateString();
}
